import { subDays, subHours, subMinutes } from 'date-fns';
import { format } from 'date-fns/format';

import config from ':cloud/config';
import { EVENT_TYPE_WALLET_ACTIVITY, WEBHOOK_STATUS } from ':cloud/widgets/webhooks/constants';

export const eventTypesMap = {
  EVENT_TYPE_ERC20_TRANSFER: 'ERC20 Transfer',
  EVENT_TYPE_ERC721_TRANSFER: 'ERC721 Transfer',
  EVENT_TYPE_WALLET_ACTIVITY: 'Wallet Activity',
};

export const networksMap = {
  'base-mainnet': 'Base Mainnet',
  'base-sepolia': 'Base Sepolia',
};

const statusMap = {
  default: 'Active',
  [WEBHOOK_STATUS.active]: 'Active',
  [WEBHOOK_STATUS.deactivated]: 'Deactivated',
};

export function getRPCEndpointURL(tokenId: string, isTestnet: boolean) {
  if (!tokenId) return 'Loading...';
  return `${config.developerAPIURL}/rpc/v1/${isTestnet ? 'base-sepolia' : 'base'}/${tokenId}`;
}

export function getEventTypeProps(eventType: string) {
  return {
    isWalletActivity: eventType === EVENT_TYPE_WALLET_ACTIVITY,
  };
}

export function getEventType(eventType: string) {
  return (eventTypesMap[eventType] || eventType) as string;
}

export function getNetwork(network: string) {
  return (networksMap[network] || network) as string;
}

export function getStatus(status: string | undefined) {
  return (statusMap[status || 'default'] || status) as string;
}

export function validateEthereumAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}

export function formatLogDate(dateString: string) {
  const date = new Date(dateString);
  const formattedDate = format(date, 'MM/dd/yy H:mm:ss');
  return formattedDate;
}

export function getISOFormattedTimeAgo(amount: number, unit: 'minutes' | 'hours' | 'days') {
  let date: Date;

  if (unit === 'minutes') {
    date = subMinutes(new Date(), amount);
  } else if (unit === 'hours') {
    date = subHours(new Date(), amount);
  } else {
    date = subDays(new Date(), amount);
  }

  const formatted = date.toISOString();

  return formatted;
}
